import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gp-modal" }
const _hoisted_2 = { class: "gp-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Pick matches", -1)
const _hoisted_4 = { class: "gp-body" }
const _hoisted_5 = { class: "gp-leagues" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "gp-league-name" }
const _hoisted_8 = { class: "gp-matches" }
const _hoisted_9 = { class: "gp-league-title" }
const _hoisted_10 = {
  key: 0,
  class: "gp-selected-row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "gp-selected-label" }, "Selected:", -1)
const _hoisted_12 = { class: "gp-selected-chips" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "gp-chip-x",
  type: "button",
  "aria-label": "remove"
}, "×", -1)
const _hoisted_15 = { class: "gp-grid" }
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = { class: "gp-date" }
const _hoisted_18 = { class: "gp-teams" }
const _hoisted_19 = { class: "gp-team" }
const _hoisted_20 = { class: "gp-team" }
const _hoisted_21 = {
  key: 0,
  class: "gp-pill"
}
const _hoisted_22 = {
  key: 0,
  class: "gp-empty"
}
const _hoisted_23 = { class: "gp-footer" }
const _hoisted_24 = { class: "gp-count" }
const _hoisted_25 = { class: "gp-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gp-backdrop",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.close()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.q) = $event)),
                class: "gp-search",
                placeholder: "Search leagues or teams"
              }, null, 512), [
                [_vModelText, _ctx.q]
              ])
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("aside", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLeagues, (lg) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: lg.id,
                    class: _normalizeClass(["gp-league", { active: lg.id === _ctx.activeLeagueId }]),
                    onClick: ($event: any) => (_ctx.setLeague(lg.id)),
                    type: "button"
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(lg.name), 1)
                  ], 10, _hoisted_6))
                }), 128))
              ]),
              _createElementVNode("main", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.activeLeague?.name || '—'), 1),
                (_ctx.selectedList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedList, (opt) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "gp-chip",
                            key: opt.id,
                            onClick: ($event: any) => (_ctx.toggle(opt.id)),
                            title: "Remove"
                          }, [
                            _createTextVNode(_toDisplayString(opt.homeTeamName) + " – " + _toDisplayString(opt.awayTeamName) + " ", 1),
                            _hoisted_14
                          ], 8, _hoisted_13))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueMatches, (g) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: g.id,
                      class: _normalizeClass(["gp-card", { selected: _ctx.isSelected(g.id) }]),
                      onClick: ($event: any) => (_ctx.toggle(g.id)),
                      type: "button",
                      title: g.leagueName
                    }, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDateCustom(g.gameDate)), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(g.homeTeamName), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(g.awayTeamName), 1)
                      ]),
                      (_ctx.isSelected(g.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.mode === 'multiple' ? 'Selected' : 'Picked'), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_16))
                  }), 128)),
                  (_ctx.leagueMatches.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "No matches"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.selected.size) + " selected", 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "gp-btn ghost",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearSel && _ctx.clearSel(...args)))
                }, "Clear"),
                _createElementVNode("button", {
                  class: "gp-btn ghost",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "gp-btn primary",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                }, "Add")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}